import React from 'react'
import LoginAndRegisterContent from './components/login/LoginAndRegisterContent'

const RegisterScreen = () => <LoginAndRegisterContent type='REGISTER' />

export default RegisterScreen
